import { CommonModule } from '@angular/common'
import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core'
import { accordionWithOverflowFix } from '../../animations'
import { IconComponent } from '../icon'

@Component({
  selector: 'ftr-composable-collapse',
  templateUrl: './composable-collapse.component.html',
  styleUrls: ['./composable-collapse.component.css'],
  animations: [accordionWithOverflowFix],
  standalone: true,
  imports: [CommonModule, IconComponent],
})
export class ComposableCollapseComponent {
  @Input() isOpen: boolean = false

  // Always shown
  @Input() headerTemplate: TemplateRef<any> | null = null

  // Shown when open
  @Input() bodyTemplate: TemplateRef<any>

  @ViewChild('header')
  header: ElementRef

  public handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.preventDefault()

      if (event.target === this.header.nativeElement) {
        this.onHeaderClick(event)
      }
    }
  }

  public onHeaderClick(event: Event): void {
    if (event.currentTarget === this.header.nativeElement) {
      this.isOpen = !this.isOpen
    }
  }
}
